import axios from 'axios'
import { Message, MessageBox } from 'element-ui'
import { UserModule } from '@/store/modules/user'
// import { LogHelper } from "@/common/LogHelper";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";

//原始请求逻辑
const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  timeout: 5000
})
// Request interceptors
service.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    if (UserModule.token) {
      config.headers['X-Access-Token'] = UserModule.token
    }
    return config
  },
  (error) => {
    Promise.reject(error)
  }
)
// Response interceptors
service.interceptors.response.use(
  (response) => {
    // Some example codes here:
    // code == 20000: success
    // code == 50001: invalid access token
    // code == 50002: already login in other place
    // code == 50003: access token expired
    // code == 50004: invalid user (user not exist)
    // code == 50005: username or password is incorrect
    // You can change this part for your own usage.
    const res = response.data
    if (res.code !== 20000) {
      Message({
        message: res.message || 'Error',
        type: 'error',
        duration: 5 * 1000
      })
      if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
        MessageBox.confirm(
          'You have been logged out, try to login again.',
          'Log out',
          {
            confirmButtonText: 'Relogin',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        ).then(() => {
          UserModule.ResetToken()
          location.reload() // To prevent bugs from vue-router
        })
      }
      return Promise.reject(new Error(res.message || 'Error'))
    } else {
      return response.data
    }
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)

//业务网关请求逻辑
const businessService = axios.create({
  // baseURL: process.env.VUE_APP_BASE_API,
  // baseURL: serviceUrl.serverUrl,
  // baseURL: "http://10.130.133.33:15229",
  timeout: 6000
})
// Request interceptors
businessService.interceptors.request.use(
  (config) => {
    // Add X-Access-Token header to every request, you can add other custom headers here
    // if (UserModule.token) {
    //   config.headers['X-Access-Token'] = UserModule.token
    // }
    debugger;
    console.warn('请求参数=>业务网关：');
    config.baseURL = "http://" + SystemConfigModule.systemData.ServerConfig.ServerIP + ":" + SystemConfigModule.systemData.ServerConfig.ServerPort;
    console.warn(config);
    // if (true) {
    //   //计算签名和token
    //   let data = config.data;
    //   var strLengthNumber = generateSignature.GetByteArrayLength(JSON.stringify(data));//得到字符串长度
    //   var strLength = generateSignature.Pad(strLengthNumber, 8);//长度保留8位整数
    //   var totalStr = strLength + JSON.stringify(data);//长度字符和原始字符相加
    //   var totalStrArray = generateSignature.GetByteArray(totalStr);
    //   var signature = md5(totalStrArray);
    //   var token = "";
    //   if (config.params == undefined) {
    //     config.params = {}
    //   }
    //   LogHelper.WriteLog(config);
    //   config.params.signature = signature;
    //   config.params.token = token;
    //   //计算结束
    //   config.baseURL = serviceUrl.serverUrl;
    // }
    return config
  },
  (error) => {
    console.error('请求异常=>业务网关：');
    console.error(error);
    Promise.reject(error)
  }
)
// Response interceptors
businessService.interceptors.response.use(
  (response) => {
    console.warn('业务网关=>返回结果：');
    console.warn(response);
    return response;
  },
  (error) => {
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    console.error('businessService出现异常：');
    console.error(error);
    return Promise.reject(error)
  }
)

//三段码网关请求逻辑
//todo

//监控网关请求逻辑
const monitorService = axios.create({
  timeout: 2000
})
monitorService.interceptors.request.use(
  (config) => {
    debugger;
    console.warn('请求参数=>监控网关：');
    config.baseURL = "http://" + SystemConfigModule.systemData.MonitorConfig.MonitorIP + ":" + SystemConfigModule.systemData.MonitorConfig.MonitorPort;
    console.warn(config);
    return config
  },
  (error) => {
    console.error('请求异常=>监控网关：');
    console.error(error);
    Promise.reject(error)
  }
)
monitorService.interceptors.response.use(
  (response) => {
    console.warn('监控网关=>返回结果：');
    console.warn(response);
    return response;
  },
  (error) => {
    console.error('monitorService出现异常：');
    console.error(error);
    Message({
      message: error.message,
      type: 'error',
      duration: 5 * 1000
    })
    return Promise.reject(error)
  }
)
export default { service, businessService, monitorService }
